// Localized error messages by country code
const localizedErrorMessages = {
  // English (default) - used for US, UK, AU, etc.
  'en': {
    phone: {
      invalid_phone_format: 'Invalid phone number. Please enter a valid phone number.',
      carrier_not_supported: 'Your mobile carrier is not supported for this service.',
      service_unavailable: 'Service not available in your country.',
      invalid_format: 'Please enter a valid phone number format.',
      unsupported_destination: 'Invalid phone number. Please enter a valid phone number.',
      default: 'Invalid phone number or carrier not supported. Please check your number and try again.'
    },
    pin: {
      invalid_pin_code: 'Incorrect PIN code. Please check your SMS and try again.',
      expired: 'PIN code has expired. Please request a new one.',
      verification_failed: 'PIN verification failed. Please check your code and try again.',
      invalid_code: 'Invalid PIN code. Please enter the code from your SMS.',
      unsupported_destination: 'Incorrect PIN code. Please check your SMS and try again.',
      default: 'Incorrect PIN code. Please check your SMS and try again.'
    },
    general: {
      connection_lost: 'Connection lost. Please try again.',
      missing_info: 'Missing required information. Please try again.',
      service_not_found: 'Service not found. Please contact support.',
      config_error: 'Configuration error. Please contact support.',
      invalid_session: 'Invalid session. Please start over.',
      network_error: 'Network error. Please check your connection and try again.',
      server_error: 'Server error. Please try again later.',
      unknown_error: 'An unexpected error occurred. Please try again.',
      default: 'An error occurred. Please try again.'
    }
  },
  
  // Romanian
  'ro': {
    phone: {
      invalid_phone_format: 'Format număr de telefon invalid. Vă rugăm să introduceți un număr de telefon valid.',
      carrier_not_supported: 'Operatorul dumneavoastră mobil nu este suportat pentru acest serviciu.',
      service_unavailable: 'Serviciul nu este disponibil în țara dumneavoastră.',
      invalid_format: 'Vă rugăm să introduceți un format valid de număr de telefon.',
      unsupported_destination: 'Număr de telefon invalid. Vă rugăm să introduceți un număr de telefon valid.',
      default: 'Format număr de telefon invalid sau operatorul nu este suportat. Vă rugăm să verificați numărul și să încercați din nou.'
    },
    pin: {
      invalid_pin_code: 'Cod PIN incorect. Vă rugăm să verificați SMS-ul și să încercați din nou.',
      expired: 'Codul PIN a expirat. Vă rugăm să solicitați unul nou.',
      verification_failed: 'Verificarea codului PIN a eșuat. Vă rugăm să verificați codul și să încercați din nou.',
      invalid_code: 'Cod PIN invalid. Vă rugăm să introduceți codul din SMS.',
      unsupported_destination: 'Cod PIN incorect. Vă rugăm să verificați SMS-ul și să încercați din nou.',
      default: 'Cod PIN incorect. Vă rugăm să verificați SMS-ul și să încercați din nou.'
    },
    general: {
      connection_lost: 'Conexiune pierdută. Vă rugăm să încercați din nou.',
      missing_info: 'Informații necesare lipsesc. Vă rugăm să încercați din nou.',
      service_not_found: 'Serviciul nu a fost găsit. Vă rugăm să contactați suportul.',
      config_error: 'Eroare de configurare. Vă rugăm să contactați suportul.',
      invalid_session: 'Sesiune invalidă. Vă rugăm să începeți din nou.',
      network_error: 'Eroare de rețea. Vă rugăm să verificați conexiunea și să încercați din nou.',
      server_error: 'Eroare server. Vă rugăm să încercați mai târziu.',
      unknown_error: 'A apărut o eroare neașteptată. Vă rugăm să încercați din nou.',
      default: 'A apărut o eroare. Vă rugăm să încercați din nou.'
    }
  },

  // Swedish
  'sv': {
    phone: {
      invalid_phone_format: 'Ogiltigt telefonnummerformat. Vänligen ange ett giltigt telefonnummer.',
      carrier_not_supported: 'Din mobiloperatör stöds inte för denna tjänst.',
      service_unavailable: 'Tjänsten är inte tillgänglig i ditt land.',
      invalid_format: 'Vänligen ange ett giltigt telefonnummerformat.',
      unsupported_destination: 'Ogiltigt telefonnummer. Vänligen ange ett giltigt telefonnummer.',
      default: 'Ogiltigt telefonnummerformat eller operatör stöds inte. Vänligen kontrollera ditt nummer och försök igen.'
    },
    pin: {
      invalid_pin_code: 'Felaktig PIN-kod. Vänligen kontrollera ditt SMS och försök igen.',
      expired: 'PIN-koden har gått ut. Vänligen begär en ny.',
      verification_failed: 'PIN-verifiering misslyckades. Vänligen kontrollera din kod och försök igen.',
      invalid_code: 'Ogiltig PIN-kod. Vänligen ange koden från ditt SMS.',
      unsupported_destination: 'Felaktig PIN-kod. Vänligen kontrollera ditt SMS och försök igen.',
      default: 'Felaktig PIN-kod. Vänligen kontrollera ditt SMS och försök igen.'
    },
    general: {
      connection_lost: 'Anslutningen förlorad. Vänligen försök igen.',
      missing_info: 'Nödvändig information saknas. Vänligen försök igen.',
      service_not_found: 'Tjänsten hittades inte. Vänligen kontakta support.',
      config_error: 'Konfigurationsfel. Vänligen kontakta support.',
      invalid_session: 'Ogiltig session. Vänligen börja om.',
      network_error: 'Nätverksfel. Vänligen kontrollera din anslutning och försök igen.',
      server_error: 'Serverfel. Vänligen försök igen senare.',
      unknown_error: 'Ett oväntat fel inträffade. Vänligen försök igen.',
      default: 'Ett fel inträffade. Vänligen försök igen.'
    }
  },

  // Dutch
  'nl': {
    phone: {
      invalid_phone_format: 'Ongeldig telefoonnummerformaat. Voer een geldig telefoonnummer in.',
      carrier_not_supported: 'Uw mobiele provider wordt niet ondersteund voor deze service.',
      service_unavailable: 'Service niet beschikbaar in uw land.',
      invalid_format: 'Voer een geldig telefoonnummerformaat in.',
      unsupported_destination: 'Ongeldig telefoonnummer. Voer een geldig telefoonnummer in.',
      default: 'Ongeldig telefoonnummerformaat of provider niet ondersteund. Controleer uw nummer en probeer opnieuw.'
    },
    pin: {
      invalid_pin_code: 'Onjuiste PIN-code. Controleer uw SMS en probeer opnieuw.',
      expired: 'PIN-code is verlopen. Vraag een nieuwe aan.',
      verification_failed: 'PIN-verificatie mislukt. Controleer uw code en probeer opnieuw.',
      invalid_code: 'Ongeldige PIN-code. Voer de code uit uw SMS in.',
      unsupported_destination: 'Onjuiste PIN-code. Controleer uw SMS en probeer opnieuw.',
      default: 'Onjuiste PIN-code. Controleer uw SMS en probeer opnieuw.'
    },
    general: {
      connection_lost: 'Verbinding verloren. Probeer opnieuw.',
      missing_info: 'Vereiste informatie ontbreekt. Probeer opnieuw.',
      service_not_found: 'Service niet gevonden. Neem contact op met support.',
      config_error: 'Configuratiefout. Neem contact op met support.',
      invalid_session: 'Ongeldige sessie. Begin opnieuw.',
      network_error: 'Netwerkfout. Controleer uw verbinding en probeer opnieuw.',
      server_error: 'Serverfout. Probeer later opnieuw.',
      unknown_error: 'Er is een onverwachte fout opgetreden. Probeer opnieuw.',
      default: 'Er is een fout opgetreden. Probeer opnieuw.'
    }
  },

  // Czech
  'cs': {
    phone: {
      invalid_phone_format: 'Neplatný formát telefonního čísla. Zadejte platné telefonní číslo.',
      carrier_not_supported: 'Váš mobilní operátor není podporován pro tuto službu.',
      service_unavailable: 'Služba není dostupná ve vaší zemi.',
      invalid_format: 'Zadejte platný formát telefonního čísla.',
      unsupported_destination: 'Neplatné telefonní číslo. Zadejte platné telefonní číslo.',
      default: 'Neplatný formát telefonního čísla nebo operátor není podporován. Zkontrolujte své číslo a zkuste to znovu.'
    },
    pin: {
      invalid_pin_code: 'Nesprávný PIN kód. Zkontrolujte svou SMS a zkuste to znovu.',
      expired: 'PIN kód vypršel. Požádejte o nový.',
      verification_failed: 'Ověření PIN kódu selhalo. Zkontrolujte svůj kód a zkuste to znovu.',
      invalid_code: 'Neplatný PIN kód. Zadejte kód ze své SMS.',
      unsupported_destination: 'Nesprávný PIN kód. Zkontrolujte svou SMS a zkuste to znovu.',
      default: 'Nesprávný PIN kód. Zkontrolujte svou SMS a zkuste to znovu.'
    },
    general: {
      connection_lost: 'Připojení ztraceno. Zkuste to znovu.',
      missing_info: 'Chybí požadované informace. Zkuste to znovu.',
      service_not_found: 'Služba nebyla nalezena. Kontaktujte podporu.',
      config_error: 'Chyba konfigurace. Kontaktujte podporu.',
      invalid_session: 'Neplatná relace. Začněte znovu.',
      network_error: 'Chyba sítě. Zkontrolujte své připojení a zkuste to znovu.',
      server_error: 'Chyba serveru. Zkuste to později.',
      unknown_error: 'Došlo k neočekávané chybě. Zkuste to znovu.',
      default: 'Došlo k chybě. Zkuste to znovu.'
    }
  },

  // Serbian
  'sr': {
    phone: {
      invalid_phone_format: 'Nevažeći format broja telefona. Molimo unesite važeći broj telefona.',
      carrier_not_supported: 'Vaš mobilni operater nije podržan za ovu uslugu.',
      service_unavailable: 'Usluga nije dostupna u vašoj zemlji.',
      invalid_format: 'Molimo unesite važeći format broja telefona.',
      unsupported_destination: 'Nevažeći broj telefona. Molimo unesite važeći broj telefona.',
      default: 'Nevažeći format broja telefona ili operater nije podržan. Molimo proverite vaš broj i pokušajte ponovo.'
    },
    pin: {
      invalid_pin_code: 'Netačan PIN kod. Molimo proverite vaš SMS i pokušajte ponovo.',
      expired: 'PIN kod je istekao. Molimo zatražite novi.',
      verification_failed: 'Verifikacija PIN koda nije uspela. Molimo proverite vaš kod i pokušajte ponovo.',
      invalid_code: 'Nevažeći PIN kod. Molimo unesite kod iz vašeg SMS-a.',
      unsupported_destination: 'Netačan PIN kod. Molimo proverite vaš SMS i pokušajte ponovo.',
      default: 'Netačan PIN kod. Molimo proverite vaš SMS i pokušajte ponovo.'
    },
    general: {
      connection_lost: 'Veza je izgubljena. Molimo pokušajte ponovo.',
      missing_info: 'Nedostaju potrebne informacije. Molimo pokušajte ponovo.',
      service_not_found: 'Usluga nije pronađena. Molimo kontaktirajte podršku.',
      config_error: 'Greška u konfiguraciji. Molimo kontaktirajte podršku.',
      invalid_session: 'Nevažeća sesija. Molimo počnite iznova.',
      network_error: 'Greška mreže. Molimo proverite vašu konekciju i pokušajte ponovo.',
      server_error: 'Greška servera. Molimo pokušajte kasnije.',
      unknown_error: 'Dogodila se neočekivana greška. Molimo pokušajte ponovo.',
      default: 'Dogodila se greška. Molimo pokušajte ponovo.'
    }
  },

  // French
  'fr': {
    phone: {
      invalid_phone_format: 'Format de numéro de téléphone invalide. Veuillez saisir un numéro de téléphone valide.',
      carrier_not_supported: 'Votre opérateur mobile n\'est pas pris en charge pour ce service.',
      service_unavailable: 'Service non disponible dans votre pays.',
      invalid_format: 'Veuillez saisir un format de numéro de téléphone valide.',
      unsupported_destination: 'Numéro de téléphone invalide. Veuillez saisir un numéro de téléphone valide.',
      default: 'Format de numéro de téléphone invalide ou opérateur non pris en charge. Veuillez vérifier votre numéro et réessayer.'
    },
    pin: {
      invalid_pin_code: 'Code PIN incorrect. Veuillez vérifier votre SMS et réessayer.',
      expired: 'Le code PIN a expiré. Veuillez en demander un nouveau.',
      verification_failed: 'La vérification du code PIN a échoué. Veuillez vérifier votre code et réessayer.',
      invalid_code: 'Code PIN invalide. Veuillez saisir le code de votre SMS.',
      unsupported_destination: 'Code PIN incorrect. Veuillez vérifier votre SMS et réessayer.',
      default: 'Code PIN incorrect. Veuillez vérifier votre SMS et réessayer.'
    },
    general: {
      connection_lost: 'Connexion perdue. Veuillez réessayer.',
      missing_info: 'Informations requises manquantes. Veuillez réessayer.',
      service_not_found: 'Service non trouvé. Veuillez contacter le support.',
      config_error: 'Erreur de configuration. Veuillez contacter le support.',
      invalid_session: 'Session invalide. Veuillez recommencer.',
      network_error: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.',
      server_error: 'Erreur serveur. Veuillez réessayer plus tard.',
      unknown_error: 'Une erreur inattendue s\'est produite. Veuillez réessayer.',
      default: 'Une erreur s\'est produite. Veuillez réessayer.'
    }
  },

  // German
  'de': {
    phone: {
      invalid_phone_format: 'Ungültiges Telefonnummernformat. Bitte geben Sie eine gültige Telefonnummer ein.',
      carrier_not_supported: 'Ihr Mobilfunkanbieter wird für diesen Service nicht unterstützt.',
      service_unavailable: 'Service in Ihrem Land nicht verfügbar.',
      invalid_format: 'Bitte geben Sie ein gültiges Telefonnummernformat ein.',
      unsupported_destination: 'Ungültige Telefonnummer. Bitte geben Sie eine gültige Telefonnummer ein.',
      default: 'Ungültiges Telefonnummernformat oder Anbieter nicht unterstützt. Bitte überprüfen Sie Ihre Nummer und versuchen Sie es erneut.'
    },
    pin: {
      invalid_pin_code: 'Falscher PIN-Code. Bitte überprüfen Sie Ihre SMS und versuchen Sie es erneut.',
      expired: 'PIN-Code ist abgelaufen. Bitte fordern Sie einen neuen an.',
      verification_failed: 'PIN-Verifizierung fehlgeschlagen. Bitte überprüfen Sie Ihren Code und versuchen Sie es erneut.',
      invalid_code: 'Ungültiger PIN-Code. Bitte geben Sie den Code aus Ihrer SMS ein.',
      unsupported_destination: 'Falscher PIN-Code. Bitte überprüfen Sie Ihre SMS und versuchen Sie es erneut.',
      default: 'Falscher PIN-Code. Bitte überprüfen Sie Ihre SMS und versuchen Sie es erneut.'
    },
    general: {
      connection_lost: 'Verbindung verloren. Bitte versuchen Sie es erneut.',
      missing_info: 'Erforderliche Informationen fehlen. Bitte versuchen Sie es erneut.',
      service_not_found: 'Service nicht gefunden. Bitte kontaktieren Sie den Support.',
      config_error: 'Konfigurationsfehler. Bitte kontaktieren Sie den Support.',
      invalid_session: 'Ungültige Sitzung. Bitte beginnen Sie von vorn.',
      network_error: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      server_error: 'Serverfehler. Bitte versuchen Sie es später erneut.',
      unknown_error: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
      default: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
    }
  },

  // Bulgarian
  'bu': {
    phone: {
      invalid_phone_format: 'Невалиден формат на телефонен номер. Моля, въведете валиден телефонен номер.',
      carrier_not_supported: 'Вашият мобилен оператор не се поддържа за тази услуга.',
      service_unavailable: 'Услугата не е достъпна във вашата страна.',
      invalid_format: 'Моля, въведете валиден формат на телефонен номер.',
      unsupported_destination: 'Невалиден телефонен номер. Моля, въведете валиден телефонен номер.',
      default: 'Невалиден формат на телефонен номер или операторът не се поддържа. Моля, проверете номера си и опитайте отново.'
    },
    pin: {
      invalid_pin_code: 'Неправилен PIN код. Моля, проверете SMS-а си и опитайте отново.',
      expired: 'PIN кодът е изтекъл. Моля, заявете нов.',
      verification_failed: 'Проверката на PIN кода неуспешна. Моля, проверете кода си и опитайте отново.',
      invalid_code: 'Невалиден PIN код. Моля, въведете кода от SMS-а си.',
      unsupported_destination: 'Неправилен PIN код. Моля, проверете SMS-а си и опитайте отново.',
      default: 'Неправилен PIN код. Моля, проверете SMS-а си и опитайте отново.'
    },
    general: {
      connection_lost: 'Връзката е загубена. Моля, опитайте отново.',
      missing_info: 'Липсва необходима информация. Моля, опитайте отново.',
      service_not_found: 'Услугата не е намерена. Моля, свържете се с поддръжката.',
      config_error: 'Грешка в конфигурацията. Моля, свържете се с поддръжката.',
      invalid_session: 'Невалидна сесия. Моля, започнете отново.',
      network_error: 'Мрежова грешка. Моля, проверете връзката си и опитайте отново.',
      server_error: 'Сървърна грешка. Моля, опитайте по-късно.',
      unknown_error: 'Възникна неочаквана грешка. Моля, опитайте отново.',
      default: 'Възникна грешка. Моля, опитайте отново.'
    }
  },

  // Slovenian
  'sl': {
    phone: {
      invalid_phone_format: 'Neveljavna oblika telefonske številke. Prosimo, vnesite veljavno telefonsko številko.',
      carrier_not_supported: 'Vaš mobilni operater ni podprt za to storitev.',
      service_unavailable: 'Storitev ni na voljo v vaši državi.',
      invalid_format: 'Prosimo, vnesite veljavno obliko telefonske številke.',
      unsupported_destination: 'Neveljavna telefonska številka. Prosimo, vnesite veljavno telefonsko številko.',
      default: 'Neveljavna oblika telefonske številke ali operater ni podprt. Prosimo, preverite svojo številko in poskusite znova.'
    },
    pin: {
      invalid_pin_code: 'Napačna PIN koda. Prosimo, preverite svoj SMS in poskusite znova.',
      expired: 'PIN koda je potekla. Prosimo, zahtevajte novo.',
      verification_failed: 'Preverjanje PIN kode ni uspelo. Prosimo, preverite svojo kodo in poskusite znova.',
      invalid_code: 'Neveljavna PIN koda. Prosimo, vnesite kodo iz svojega SMS sporočila.',
      unsupported_destination: 'Napačna PIN koda. Prosimo, preverite svoj SMS in poskusite znova.',
      default: 'Napačna PIN koda. Prosimo, preverite svoj SMS in poskusite znova.'
    },
    general: {
      connection_lost: 'Povezava je izgubljena. Prosimo, poskusite znova.',
      missing_info: 'Manjkajo potrebne informacije. Prosimo, poskusite znova.',
      service_not_found: 'Storitev ni bila najdena. Prosimo, kontaktirajte podporo.',
      config_error: 'Napaka v konfiguraciji. Prosimo, kontaktirajte podporo.',
      invalid_session: 'Neveljavna seja. Prosimo, začnite znova.',
      network_error: 'Napaka omrežja. Prosimo, preverite svojo povezavo in poskusite znova.',
      server_error: 'Napaka strežnika. Prosimo, poskusite znova pozneje.',
      unknown_error: 'Prišlo je do nepričakovane napake. Prosimo, poskusite znova.',
      default: 'Prišlo je do napake. Prosimo, poskusite znova.'
    }
  }
};


// Helper function to get localized error message
function getLocalizedErrorMessage(errorType, errorKey, languageCode) {
  // Use language code 
  const language = languageCode || 'en';
  
  // Get the language-specific messages
  const languageMessages = localizedErrorMessages[language] || localizedErrorMessages['en'];
  
  // Get messages for error type (phone/pin/general)
  const typeMessages = languageMessages[errorType] || languageMessages['general'];
  
  // Return specific message or default
  return typeMessages[errorKey] || typeMessages['default'];
}

// Map backend error messages to user-friendly messages
// Based on actual backend analysis: RespMessage presets and client implementations
export function mapBackendError(backendMessage, errorType = 'general', languageCode = null) {
  //if backend doesn't provide a message
  if (!backendMessage) {
    // Be more specific based on the context/step where error occurred
    if (errorType === 'phone') {
      // This happens when:
      // 1. gear.msisdn_global_format() returns valid=false (invalid phone format)
      // 2. dcb_intel.web_inaugurate() returns sent=false (carrier/external API issue)
      return getLocalizedErrorMessage('phone', 'default', languageCode);
    }
    
    if (errorType === 'pin') {
      // This happens when:
      // 1. dcb_intel.confirm() returns verified=false (wrong PIN)
      // 2. Anti-fraud check fails
      return getLocalizedErrorMessage('pin', 'default', languageCode);
    }
    
    // Generic fallback
    return getLocalizedErrorMessage('general', 'default', languageCode);
  }

  // Convert backend message to lowercase for consistent matching
  const message = backendMessage.toLowerCase();

  // Backend error mapping to localized message keys
  const backendErrorToKey = {
    // From RespMessage class in presets.py
    'lost': 'connection_lost',
    'unsufficient': 'missing_info',
    'insufficient': 'missing_info',
    'not_found': 'service_not_found',
    'client_not_found': 'config_error',
    'unsupported destination': 'unsupported_destination',
    'client_not_authorized': 'config_error',
    'invalid_click_id': 'invalid_session',
    'config_error': 'config_error',
    'unknown_error': 'unknown_error',
    'invalid_static_page': 'service_not_found',
    'invalid_page': 'service_not_found',
    'invalid_domain': 'config_error',
    
    // From DCB validation in dcb.py
    'invalid_msisdn': 'invalid_phone_format',
    'invalid_phone_format': 'invalid_phone_format',
    'carrier_not_supported': 'carrier_not_supported',
    'invalid_pin_code': 'invalid_pin_code',
    
    // Generic client error messages that might be returned
    'msg': 'default',
    'message': 'default',
    'error': 'default',
    
    // Network/timeout errors
    'network_error': 'network_error',
    'timeout': 'network_error',
    'server_error': 'server_error',
  };

  // Check for exact matches first and return localized message
  for (const [key, messageKey] of Object.entries(backendErrorToKey)) {
    if (message === key || message.includes(key)) {
      // Determine the appropriate error type based on the message key
      let localizedErrorType = 'general';
      
      if (messageKey === 'unsupported_destination') {
        localizedErrorType = errorType === 'pin' ? 'pin' : 'phone';
      } else if (['invalid_phone_format', 'carrier_not_supported'].includes(messageKey)) {
        localizedErrorType = 'phone';
      } else if (['invalid_pin_code'].includes(messageKey)) {
        localizedErrorType = 'pin';
      }
       

      
      return getLocalizedErrorMessage(localizedErrorType, messageKey, languageCode);
    }
  }

  // Context-specific error handling for when we have a message but it's generic
  if (errorType === 'phone') {
    // Phone number validation errors
    if (message.includes('invalid') || message.includes('msisdn')) {
      return getLocalizedErrorMessage('phone', 'invalid_phone_format', languageCode);
    }
    if (message.includes('not supported') || message.includes('carrier')) {
      return getLocalizedErrorMessage('phone', 'carrier_not_supported', languageCode);
    }
    if (message.includes('country')) {
      return getLocalizedErrorMessage('phone', 'service_unavailable', languageCode);
    }
    if (message.includes('format') || message.includes('number')) {
      return getLocalizedErrorMessage('phone', 'invalid_format', languageCode);
    }
  }

  if (errorType === 'pin') {
    // PIN verification errors
    if (message.includes('invalid') || message.includes('wrong') || message.includes('incorrect')) {
      return getLocalizedErrorMessage('pin', 'invalid_pin_code', languageCode);
    }
    if (message.includes('expired') || message.includes('timeout')) {
      return getLocalizedErrorMessage('pin', 'expired', languageCode);
    }
    if (message.includes('failed') || message.includes('verification')) {
      return getLocalizedErrorMessage('pin', 'verification_failed', languageCode);
    }
    if (message.includes('code') || message.includes('pin')) {
      return getLocalizedErrorMessage('pin', 'invalid_code', languageCode);
    }
  }

  // If no specific mapping found, clean up the message or use localized fallback
      return cleanMessage(backendMessage, languageCode);
}

export function cleanMessage(message, languageCode = null) {
  if (!message) {
    return getLocalizedErrorMessage('general', 'default', languageCode);
  }
  
  // Try to clean up the message, but if it's still generic, use localized fallback
  const cleaned = message
    .split("_")
    .join(" ")
    .toLowerCase()
    .replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    
      // if the cleaned message is too generic, use localized version
    if (cleaned.toLowerCase().includes('error') || cleaned.toLowerCase().includes('failed')) {
      return getLocalizedErrorMessage('general', 'default', languageCode);
  }
  
  return cleaned;
} 